import { render, staticRenderFns } from "./ChangeNotification.vue?vue&type=template&id=62a59c4a"
import script from "./ChangeNotification.vue?vue&type=script&lang=js"
export * from "./ChangeNotification.vue?vue&type=script&lang=js"
import style0 from "./ChangeNotification.vue?vue&type=style&index=0&id=62a59c4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports